export default "__VITE_ASSET__BEJGhIvO__"